import { View, Utils } from '../vendor/kerneljs';
import moment from 'moment';
import { default as localeDA } from '../locales/da';
import { default as localeEN } from '../locales/en';
import Pikaday from 'pikaday';

const DatePickerPikaday = View.extend({

	selectedDate: null,

	events: {
		'focus .form__item, .form-input': 'onFocus',
		'blur .form__item, .form-input': 'onBlur'
		// ,'change .form__item':'changeHandler'
	},

	useCalendarHeader: false,

	datePicker: null,

	nativeFormat: 'YYYY-MM-DD',
	prettyFormat: 'DD / MM / YYYY',


	initialize: function () {
		if (this.settings.format) {
			this.prettyFormat = this.settings.format;
		}
	
		if (this.hasClass('is-bound')) return;
	
		this.dateChosen = false;
		this.currentLocale = this.getCurrentLocale();
	
		moment.updateLocale(this.currentLocale.abbr, this.currentLocale);
	
		this.formItem = this.find('.form__item, .form-input');
	
		if (this.useCalendarHeader) {
			this.setupCalendarHeader();
		}
	
		const data = this.getInitialData();
	
		if (this.shouldUseNativeMobilePicker()) {
			this.setupNativeMobilePicker(data);
		} else {
			this.setupCustomDatePicker(data);
		}
	
		this.addEventListeners();
	},
	
	getCurrentLocale: function () {
		const lang = document.body.dataset.language || "da";
		return lang === "da" ? localeDA : localeEN;
	},
	
	setupCalendarHeader: function () {
		const calendarHeaderTemplateContent = Utils.find('#calendarHeaderTemplate')[0].innerHTML;
		this.headerEl = Utils.createEl('div.pika-lendar__header');
		this.headerEl.innerHTML = calendarHeaderTemplateContent;
	},
	
	getInitialData: function () {
		const preFilled = this.hasClass('is-filled');
		const preData = {
			value: this.formItem.getAttribute('value'),
			maxdate: this.formItem.getAttribute('max'),
			mindate: this.formItem.getAttribute('min')
		};
	
		let data = {};
		data.value = this.getDateValue(preData.value, preFilled);
		data.mindate = this.getDateMin(preData.mindate, preFilled);
		data.maxdate = this.getDateMax(preData.maxdate, preFilled);
	
		return data;
	},
	
	getDateValue: function (value, preFilled) {
		if(value)
			return moment(value, this.prettyFormat).toDate();
		return preFilled ? new Date() : null;
	},
	
	getDateMin: function (mindate, preFilled) {
		if(mindate)
			return moment(mindate, this.prettyFormat).toDate();
		return preFilled ? this.adjustYear(new Date(), -15) : null;
	},
	
	getDateMax: function (maxdate, preFilled) {
		if(maxdate)
			return moment(maxdate, this.prettyFormat).toDate();
		return preFilled ? this.adjustYear(new Date(), 15) : null;
	},
	
	adjustYear: function (date, years) {
		date.setFullYear(date.getFullYear() + years);
		return date;
	},
	
	shouldUseNativeMobilePicker: function () {
		return this.settings.nativeMobile && ('ontouchstart' in window || navigator.msMaxTouchPoints);
	},
	
	setupNativeMobilePicker: function (data) {
		this.formItem.setAttribute('type', 'date');
		this.formItem.removeAttribute('readonly');
	
		const nativeFormatData = {
			max: moment(data.maxdate).format(this.nativeFormat),
			min: moment(data.mindate).format(this.nativeFormat)
		};
		this.formItem.setAttribute('max', nativeFormatData.max);
		this.formItem.setAttribute('min', nativeFormatData.min);
		this.formItem.valueAsDate = data.value;
	},
	
	setupCustomDatePicker: function (data) {
		this.addClass('is-bound');
		this.formItem = this.find('.form__item, .form-input');
	
		this.opt = {
			field: this.formItem,
			firstDay: 1,
			position: "bottom",
			reposition: false,
			format: this.prettyFormat,
			theme: this.useCalendarHeader ? 'has-header' : null,
			showWeekNumber: false,
			onSelect: this.selectHandler.bind(this),
			onClose: this.closeHandler.bind(this),
			onDraw: this.drawHandler.bind(this),
			setDefaultDate: !!data.value,
			defaultDate: data.value,
			minDate: data.mindate,
			maxDate: data.maxdate,
			i18n: this.currentLocale,
			container: this.settings.container
		};
	
		this.datePicker = new Pikaday(this.opt);
		this.datePickerEl = this.datePicker.el;
	},
	
	addEventListeners: function () {
		Utils.on(document, 'datepicker:update', this.onUpdateHandler.bind(this));
		const pagewrapper = document.querySelectorAll('.page-wrapper')[0];
		if (pagewrapper) {
			pagewrapper.addEventListener('touchstart', this.defocus.bind(this));
		}
	},


	isTextInput: function (node) {
		return ['INPUT'].indexOf(node.nodeName) !== -1;
	},

	defocus: function (event) {

		let foundPika = Utils.closestByClass(event.target, 'pika-single'),
			targetIsInput = this.isTextInput(event.target),
			activeElementIsInput = this.isTextInput(document.activeElement);

		if (!targetIsInput && activeElementIsInput) {
			if (foundPika) {
				//DO NOTHING
			}
			else {
				document.activeElement.blur();
				this.onBlur();
			}
		}
	},

	resolveDate: function (val) {
		if (!val) { return }
		return moment().add(val, 'days')._d;
	},

	changeHandler: function () {
		this.dateChosen = true;
	},

	selectHandler: function (event) {
		if (this.settings.nativeMobile) return false;

		this.dateChosen = true;
		this.selectedDate = event;
	},
	closeHandler: function () {
		if (this.dateChosen) {
			this.dateChosen = false;
			// Log.fn("pikaday select")
			this.eventEmitter.emit('datepicker:change', this.settings.index);
		}
	},
	show: function () {

		if (this.datePicker) {
			this.datePicker.show();
		}
	},

	onFocus: function () {
		if (this.hasClass('is-disabled')) return false;
		this.addClass('has-focus');
		this.addClass('is-filled');

	},


	drawHandler: function () {
		if (this.useCalendarHeader) {
			this.insertCalendarHeader();
		}
	},

	insertCalendarHeader: function () {

		let pikaLendarEl = Utils.find(this.datePickerEl, '.pika-lendar')[0];
		this.datePickerEl.insertBefore(this.headerEl, pikaLendarEl);

		if (!this.selectedDate) this.selectedDate = new Date();

		let momentDate = moment(this.selectedDate),
			calendarHeader = Utils.find(this.datePickerEl, '.pika-lendar__header')[0],
			yearHolder = Utils.find(calendarHeader, '.year')[0],
			monthHolder = Utils.find(calendarHeader, '.month')[0],
			dayHolder = Utils.find(calendarHeader, '.day')[0],
			dateHolder = Utils.find(calendarHeader, '.date')[0];

		yearHolder.textContent = momentDate.format('YYYY');
		dayHolder.textContent = momentDate.format('ddd') + ".";
		dateHolder.textContent = momentDate.format('D') + ".";
		monthHolder.textContent = momentDate.format('MMMM');
	},

	onBlur: function () {
		this.removeClass('has-focus');
		if (this.formItem && this.formItem.value.length === 0) this.removeClass('is-filled');
	},


	getPicker: function () {
		return this.datePicker;
	},

	onUpdateHandler: function (customEvent) {
		let updateId = customEvent.detail.id,
			formItemId = this.formItem.getAttribute('id');
		if (updateId === formItemId) {
			let newValue = customEvent.detail.value,
				newDate = new Date(newValue);
			this.datePicker.setDate(newDate);
		}
	}
});

export default DatePickerPikaday